/**
 * How long a request may go without progress, meaning no byte sent or received and no answer from the server,
 * before it is given up on. One minute is what master-data.get, the slowest call, is allowed on the server. An
 * endpoint that needs a different value gets its own entry in the map.
 */
export class RequestTimeouts {
  static readonly DEFAULT_STALL_TIMEOUT_IN_MILLISECONDS = 60_000;
  /** What tells a request given up on from any other that got no response, since both fail with status 0. */
  static readonly STALLED_STATUS_TEXT = 'Request stalled';
  private static readonly STALL_TIMEOUT_IN_MILLISECONDS_BY_ENDPOINT: Record<string, number> = {};

  /**
   * The last segment of the path, like 'master-data.get' or 'task.close'. The query string is left out, since
   * the access request carries the API credentials in it.
   */
  static endpointOf(url: string): string {
    const path = url.split('?')[0];
    const endpoint = path.substring(path.lastIndexOf('/') + 1);
    return endpoint;
  }

  static stallTimeoutFor(endpoint: string): number {
    return (
      RequestTimeouts.STALL_TIMEOUT_IN_MILLISECONDS_BY_ENDPOINT[endpoint] ??
      RequestTimeouts.DEFAULT_STALL_TIMEOUT_IN_MILLISECONDS
    );
  }
}
